import {useAuthStore} from '@/stores/auth'
import {onBeforeMount, ref} from 'vue'
import {useRoute} from 'vue-router'

export const appViewPremissions: Array<[string, string]> = [
  ['views', 'views|read'],
  ['views/:uuid', 'views|read'],
  ['roles', 'roles|read'],
  ['roles/create', 'roles|create'],
  ['roles/:uuid', 'roles|edit'],
  ['entities', 'entities|read'],
  ['entities/:entityUuid', 'attributes|read'],
  ['oqu-files', 'oqu_files|read'],
  // L2-маршруты захардкожены отдельно через VAsideMenu + constants/l2Menu.ts,
  // не привязаны к catalogmenu в БД. Здесь не повторяются.
]

const appViewPremissionsMap = new Map(appViewPremissions)

export function onViewPermissionMount(fn?: () => any) {
  const viewVisible = ref(true)
  const authStore = useAuthStore()
  const route = useRoute()

  onBeforeMount(() => {
    const viewName = route.matched[route.matched.length - 1].path.replace('/', '')
    const permission = appViewPremissionsMap.get(viewName)

    if (permission) {
      const visible = authStore.userPermissions.has(permission)
  
      viewVisible.value = visible
  
      if (visible) fn?.()
    } else {
      fn?.()
    }
  })

  return viewVisible
}
